import { sha3_512 } from 'js-sha3'
import {isWeb} from './utils'
import storage from './storage'
import {getEnv} from './env'

export const hashAuthData = (
  authData,
  fixedPart = getEnv().PASSWORD_SALT || 'SKPAY_PASSWORD_SALT'
) => {
  return sha3_512.update(authData).update(fixedPart).hex()
}

export const saveCredentials = async (deviceToken, username) => {
  // Note: on web the device_token is stored in httpOnly cookie.
  // The access_token for web will gained during the next http request
  // using /access-token endpoint
  if (!isWeb()) {
    await storage.setItem('deviceToken', deviceToken)
  }
  await storage.setItem('username', username)
}
